import { createRoot } from 'react-dom/client';

import './index.css';
import App from './App';
import { initializeSentry } from './modules/logging';

initializeSentry();

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(<App />);
